import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Actions from './Actions';
import CommentsCount from './CommentsCount';
import ReviewsCount from './ReviewsCount';

const SocialActionsStats = ({
  aliasId,
  gaEventCategory,
  keywords,
  offerCommentsCount,
  offerCoupon,
  offerId,
  offerInstructions,
  offerLikes,
  offerPrice,
  offerPriceType,
  offerStatusName,
  offerTitle,
  totalReviews,
  userId,
  className,
}) => {
  return (
    <div className={twMerge('flex items-center justify-between', className)}>
      <div className="flex items-center">
        <ReviewsCount>{totalReviews}</ReviewsCount>
        <CommentsCount offerId={offerId}>{offerCommentsCount}</CommentsCount>
      </div>
      <Actions
        aliasId={aliasId}
        gaEventCategory={gaEventCategory}
        keywords={keywords}
        offerCoupon={offerCoupon}
        offerId={offerId}
        offerInstructions={offerInstructions}
        offerLikes={offerLikes}
        offerPrice={offerPrice}
        offerPriceType={offerPriceType}
        offerStatusName={offerStatusName}
        offerTitle={offerTitle}
        userId={userId}
      />
    </div>
  );
};

SocialActionsStats.propTypes = {
  aliasId: PropTypes.number,
  gaEventCategory: PropTypes.string,
  keywords: PropTypes.arrayOf(PropTypes.string),
  offerCommentsCount: PropTypes.number,
  offerCoupon: PropTypes.string,
  offerId: PropTypes.number.isRequired,
  offerInstructions: PropTypes.string,
  offerLikes: PropTypes.number,
  offerPrice: PropTypes.number.isRequired,
  offerPriceType: PropTypes.string,
  offerStatusName: PropTypes.string,
  offerTitle: PropTypes.string.isRequired,
  totalReviews: PropTypes.number,
  userId: PropTypes.number,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default SocialActionsStats;
